// By market — share of book value, each deal counted once.
//
// A deal tagged to two markets sits under the first, so the shares sum to 100%.
// Counting a portfolio in full under both of its markets is how "about half the
// book is South Florida" appeared when the real share is about a third.
//
// Bars are neutral on purpose: red on Home always means stage, and a market is
// not a stage.
const M = (v) => `$${(v / 1e6).toFixed(1)}M`;

export default function MarketsOnce({ markets, bind }) {
  const max = markets.length ? markets[0].value : 0;
  return (
    <section data-print-block className="rounded-[14px] border border-[#3a3a3a] bg-[#242424] px-6 py-5">
      <h3 className="text-[15px] font-semibold text-[#f4f4f4]">By market</h3>
      <p className="mt-0.5 text-[12px] text-[#8a8a8a]">Share of book value · each deal counted once</p>
      <div className="mt-4">
        {markets.map((m) => (
          <div key={m.market}
            {...bind(<><div className="text-[10.5px] text-[#8a8a8a]">{m.market}</div>{M(m.value)} across {m.n} deal{m.n === 1 ? "" : "s"} · {Math.round((m.share || 0) * 100)}% of book</>)}
            className="group grid grid-cols-[128px_1fr_54px] items-center gap-3 border-b border-[#303030] py-2.5 last:border-b-0">
            <div className="text-[13px] text-[#f4f4f4]">
              {m.market}
              <small className="mt-px block text-[11px] text-[#8a8a8a]">{m.n} deal{m.n === 1 ? "" : "s"} · {M(m.value)}</small>
            </div>
            <div className="h-2 overflow-hidden rounded bg-[#2c2c2c]">
              <div className="h-full rounded-r bg-[#5c5c5c] group-hover:bg-[#747474]" style={{ width: `${max ? (m.value / max) * 100 : 0}%` }} />
            </div>
            <div className="text-right text-[13px] font-semibold text-[#f4f4f4]">{m.share != null ? `${Math.round(m.share * 100)}%` : "—"}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
